import React from 'react';
import { throttle } from 'lodash';
import { isResizeObserverSupported } from '../../../../../common/utils/is-resize-observable-supported';
export const useRemainingWidth = () => {
    const [maxWidth, setMaxWidth] = React.useState();
    const containerRef = React.useRef(null);
    const elementRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (containerRef.current && elementRef.current && isResizeObserverSupported()) {
            const observer = new ResizeObserver(throttle(([containerData]) => {
                var _a, _b;
                const { width } = containerData.contentRect;
                const elementWidth = (_b = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0;
                setMaxWidth(width - elementWidth);
            }));
            observer.observe(containerRef.current);
            return () => {
                observer.disconnect();
            };
        }
    }, []);
    return { maxWidth, containerRef, elementRef };
};
//# sourceMappingURL=use-remaining-width.js.map